import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { GeneralState } from "../../../../models/state";
import { actionTypes as CHECKOUT_AT, actionTypesB2B as CHECKOUT_B2B_AT } from "../../checkout";
import * as FWA_AT from "../../fwa/state/actionTypes";
import * as TELIA_PLAY_AT from "../../telia-play/state/actionTypes";
import { fulfilled } from "../utils";

const initialState: GeneralState = {
    announcements: [],
    showLockedOrderModal: false,
    showInvalidOrderModal: false,
    showNoneOrderModal: false,
    showEmptiedOrderModal: false,
    flash: undefined,
    checkoutCompletedNow: false,
    isAllowedToOrder: true,
    isCheckout: false,
    isSummary: false,
    isGATransactionTracked: false,
};

const general = (state = initialState, action: AnyAction): GeneralState => {
    switch (action.type) {
        case AT.GENERAL_SET_FLASH:
            return {
                ...state,
                flash: {
                    message: action.payload.message,
                    type: action.payload.type,
                    ...(action.payload.persistent ? { persistent: true } : {}),
                },
            };
        case AT.GENERAL_CLEAR_FLASH:
            if (state.flash?.persistent && !action.payload?.force) {
                return state;
            }
            return {
                ...state,
                flash: undefined,
            };
        case AT.GENERAL_SHOW_GLOBAL_MODAL:
            return {
                ...state,
                showInvalidOrderModal: !!action.payload.invalidOrder,
                showLockedOrderModal: !!action.payload.lockedOrder,
                showNoneOrderModal: !!action.payload.noneOrder,
            };
        case AT.APP_SET_IS_GA_TRANSACTION_TRACKED:
            return {
                ...state,
                isGATransactionTracked: action.isTracked,
            };
        case fulfilled(CHECKOUT_AT.CHECKOUT_EMPTY_ORDER):
            return {
                ...state,
                showEmptiedOrderModal: true,
            };
        case fulfilled(CHECKOUT_B2B_AT.B2B_SUBMIT_MANUAL_ORDER):
            return {
                ...state,
                orderId: action.payload.orderId,
            };
        case fulfilled(FWA_AT.FWA_UPDATE_CUSTOMER_AND_SUBMIT):
            return {
                ...state,
                orderRef: action.payload.orderRef,
            };
        case fulfilled(TELIA_PLAY_AT.TELIA_PLAY_SUBMIT_ORDER):
            return {
                ...state,
                orderRef: action.payload.orderRef,
            };
        default:
            return state;
    }
};

export default general;
